import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Avatar,
  Upload,
  message,
  Form,
  Button,
  Input,
  Select,
  DatePicker,
} from "antd";
import { AntDesignOutlined, UploadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { callFetchUserByID, callUpdateUserInfo } from "../../../config/api";
import { fetchAccount, setUserLoginInfo } from "../../../redux/slice/accountSlide";
import dayjs from "dayjs";
import { disabledDate } from "../../../utils/library";

const UserInfo = () => {
  const [form] = Form.useForm();
  const dispatch:any = useDispatch();
  const user = useSelector((state: any) => state.account.user);
  // const [infoAccount, setInfoAccount] = useState<any>({})
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [avatarBase64, setAvatarBase64] = useState<string | null>(
    user?.avatar ?? ""
  );

  const onFinish = async (values: any) => {
    setIsSubmit(true);
    const res = await callUpdateUserInfo({
      ...values,
      avatar: avatarBase64, // Include the base64 avatar string in the request
    });


    if (res && res.data) {
      fetchApiUserByID()
      // localStorage.removeItem("access_token");
      message.success("Cập nhật thông tin thành công !");
    } else {
      message.error("Cập nhật thất bại !");
    }

    setIsSubmit(false);
  };

  const beforeUpload = (file: File) => {
    // Convert the file to a base64 string
    const reader = new FileReader();
    reader.onloadend = () => {
      setAvatarBase64(reader.result as string);
    };
    reader.readAsDataURL(file);

    return false; // Prevent default behavior of antd Upload component
  };

  const fetchApiUserByID = async () => {
    const res = await callFetchUserByID(user?._id);
    
    const infoAccount = res?.data;
    form.setFieldsValue({...infoAccount, date_of_birth: dayjs(infoAccount?.date_of_birth)});
  };
  useEffect(() => {
    fetchApiUserByID();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user._id, isSubmit]);
  useEffect(() => {
    dispatch(fetchAccount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
        }}>
        <Row gutter={[120, 50]}>
          <Col
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 15,
              justifyContent: "center",
            }}>
            <Avatar
              style={{ border: "1px solid #eee" }}
              src={avatarBase64}
              size={{ xs: 128, sm: 128, md: 128, lg: 128, xl: 160, xxl: 160 }}
              icon={<AntDesignOutlined />}
              shape="circle"
            />
            <Upload beforeUpload={beforeUpload} showUploadList={false}>
              <Button icon={<UploadOutlined />}>Tải ảnh lên</Button>
            </Upload>
          </Col>
          <Col span={24}></Col>
        </Row>
        <Col sm={24} md={12}>
          <Form
            form={form}
            onFinish={onFinish}
            name="basic"
            style={{ maxWidth: 600 }}
            autoComplete="off">
            <Form.Item
              labelCol={{ span: 24 }} //whole column
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Email không được để trống!" },
              ]}>
              <Input disabled />
            </Form.Item>
            <Form.Item
              labelCol={{ span: 24 }} //whole column
              label="Họ tên"
              name="name"
              rules={[
                { required: true, message: "Họ tên không được để trống!" },
              ]}>
              <Input />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 24 }} //whole column
              name="date_of_birth"
              label="Ngày sinh"
              rules={[{ required: true, message: "Vui lòng nhập ngày sinh" }]}>
              <DatePicker
                style={{ width: "100%" }}
                disabledDate={disabledDate}
                format={"DD/MM/YYYY"}
                placeholder="DD/MM/YYYY"
              />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 24 }} //whole column
              label="Địa chỉ"
              name="address"
              rules={[
                {
                  required: true,
                  message: "Số điện thoại không được để trống!",
                },
              ]}>
              <Input />
            </Form.Item>
            <Form.Item
              //   hidden
              labelCol={{ span: 24 }} //whole column
              label="Giới tính"
              name="gender"
              rules={[
                {
                  required: true,
                  message: "Giới tính không được để trống!",
                },
              ]}>
              <Select
                // showSearch
                options={[
                  {
                    value: "male",
                    label: "Nam",
                  },
                  {
                    value: "female",
                    label: "Nữ",
                  },
                  {
                    value: "other",
                    label: "Khác",
                  },
                ]}
              />
            </Form.Item>
            <Button
              type="primary"
              //   htmlType="submit"
              onClick={() => {
                form.submit();
              }}>
              Xác nhận
            </Button>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default UserInfo;
